<template>
  <div class="gs-app gm-automations-refresh">
    <div class="flex h-full automations-wrapper">
      <!-- Loader -->
      <portal to="loaderTarget">
        <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
          <gd-loader :label="$t('frontend_loading')"/>
        </div>
      </portal>

      <div class="w-full py-4 gm-automations-refresh__workspace">
        <div
          class="flex mb-2 p-2 gs-refresh-controls"
          v-if="!(!selectedFilter && this.automations.length === 0)"
        >
          <div class="w-full flex justify-between items-center">
           
            <div class="flex items-center justify-center">
              <p class="font-semibold mr-2 text-grey-600">
                {{ $t('frontend_groovemail_automations_filter_by') }}
              </p>
              <gd-dropdown
                size="lg"
                maxHeight="410px"
                v-model="selectedFilter"
                :options="automationFilterOptions"
                @change="setFilter"
                divider
              />
            </div>

            <gd-button
              variant="primary"
              class="w-56 new-automation-add-btn"
              @click="opencreateautomation"
            >
              {{$t('frontend_groovemail_analytics_list_new_automation')}}
            </gd-button>
          </div>
        </div>
        <div class="flex mb-4">
          <div class="w-full p-2">
            <div v-if="this.automations.length > 0">
              <div
                v-for="(automation, index) in this.automations"
                :key="index"
                class="w-full bg-white border-t border-l border-r rounded-t rounded-r border-grey-300 automation-container gm-automations-refresh__card"
              >
                <div class="flex justify-between pt-6 px-6 pb-2">
                  <div>
                    <p class="font-semibold text-md text-deep-dark text-2xl">
                      {{
                        automation.name
                          ? automation.name
                          : this.$t('frontend_groovemail_not_available')
                      }}
                    </p>
                  </div>
                  <div class="flex justify-center items-center">
                    <div
                      :title="
                        automation.status === 1
                          ? $t(
                              'frontend_groovemail_sequence_node_status_active'
                            )
                          : $t(
                              'frontend_groovemail_sequence_node_status_inactive'
                            )
                      "
                      class="rounded-full w-4 h-4 mr-2"
                      :class="{
                        'bg-success': automation.status === 1,
                        'bg-danger': !automation.status,
                      }"
                    >
                      <span></span>
                    </div>

                    <gd-dropdown
                      class="ml-2 font-semibold"
                      size="regular"
                      :placeholder="$t('frontend_groovemail_mail_lead_actions')"
                      :options="getActionOptions(automation)"
                      @change="handleActionChange($event, index, automation)"
                      divider
                    />
                  </div>
                </div>
                <div class="flex pt-2 pb-2 px-6">
                  <div class="automation-section-trigger">
                    <div v-for="(option, index) in automation.pre_condition" :key="index" class="flex mb-4">
                    <template v-if="index === 0">
                      <div>
                        <TriggersIcon />
                      </div>
                      <div class="w-10/12 ml-4">
                        <p
                          :title="option.action"
                          class="overflow-hidden automate-text-ellipse text-grey-600 font-bold text-sm"
                        >
                          {{ option.action }}
                        </p>
                        <p
                          :title="
                            option.updatedName
                              ? option.updatedName
                              : option.name
                          "
                          class="overflow-hidden automate-text-ellipse text-deep-dark font-bold text-sm"
                        >
                          {{
                            option.updatedName
                              ? option.updatedName
                              : option.name
                          }}
                        </p>
                      </div>

                      </template>
                    </div>
                  </div>
                  <div
                    class="w-16 px-4 pt-4"
                    v-if="automation.pre_condition.length > 1"
                  >
                    <div class="border border-grey-600 border-dashed"></div>
                  </div>
                  <div
                    class="automation-section-condition"
                    v-if="automation.pre_condition.length > 1"
                  >
                    <div v-for="(option, index) in automation.pre_condition" :key="index" class="flex mb-4">
                      <template v-if="index != 0">
                        <div>
                          <ConditionsIcon />
                        </div>
                        <div class="w-10/12 ml-4">
                          <p
                            :title="option.action"
                            class="overflow-hidden automate-text-ellipse text-grey-600 font-bold text-sm"
                          >
                            {{ option.action }}
                          </p>
                          <p
                            :title="
                              option.updatedName
                                ? option.updatedName
                                : option.name
                            "
                            class="overflow-hidden automate-text-ellipse text-deep-dark font-bold text-sm"
                          >
                            {{
                              option.updatedName
                                ? option.updatedName
                                : option.name
                            }}
                          </p>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="w-16 px-4 pt-4">
                    <div class="border border-grey-600 border-dashed"></div>
                  </div>
                  <div class="automation-section-action">
                    <div v-for="(option, index) in automation.post_condition" :key="index" class="flex mb-4">
                      <div>
                        <ActionsIcon />
                      </div>
                      <div class="w-10/12 ml-4">
                        <p
                          :title="option.action"
                          class="overflow-hidden automate-text-ellipse text-grey-600 font-bold text-sm"
                        >
                          {{ option.action }}
                        </p>
                        <p
                          :title="
                            option.updatedName
                              ? option.updatedName
                              : option.name
                          "
                          class="overflow-hidden automate-text-ellipse text-deep-dark font-bold text-sm"
                        >
                          {{
                            option.updatedName
                              ? option.updatedName
                              : option.name
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!selectedFilter && this.automations.length === 0 && !isLoading"
              class="flex justify-center"
            >
              <empty-listing-state
                :empty_state_heading="'frontend_groovemail_automations_route_page_title'"
                :empty_state_sub_heading="'frontend_groovemail_automations_no_automation'"
                :empty_state_button_text="'frontend_groovemail_analytics_list_new_automation'"
                @executeDataCreation="opencreateautomation"
              ></empty-listing-state>
            </div>
            <div
              v-if="selectedFilter && this.automations.length === 0 && !isLoading"
              class="flex justify-center"
            >
              <empty-listing-state
                :empty_state_sub_heading="'frontend_dashboard_automations_no_automation_found'"
              ></empty-listing-state>
            </div>
          </div>
        </div>
      </div>
    </div>

    <gs-named-modal class="gs-refresh-controls"
      id="automationmodel"
      name="create-automation-modal"
      width="800px"
      :title="this.$t('frontend_groovemail_analytics_list_new_automation')"
      @closed="automationModalClosed()"
    >
      <automate
        ref="automationModal"
        :triggers="preTriggers"
        :actions="actions"
        :model="model"
        type="add"
        @updateModel="model = $event"
        @preFieldsUpdated="changedPreFields"
        @saveAutomation="savedetail"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
        @closeAutomationCreateModal="closeAutomationModal('add')"
      >
      </automate>
    </gs-named-modal>

    <gs-named-modal class="gs-refresh-controls"
      id="automationmodel"
      name="edit-automation-modal"
      width="800px"
      :title="this.$t('frontend_dashboard_automations_edit_automation')"
      @closed="automationModalClosed()"
    >
      <automate
        ref="automationModal"
        :triggers="preTriggers"
        :actions="actions"
        :model="model"
        type="edit"
        @updateModel="model = $event"
        @preFieldsUpdated="changedPreFields"
        @updateAutomation="updatedetail"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
        @closeAutomationCreateModal="closeAutomationModal('edit')"
      >
      </automate>
    </gs-named-modal>

    <!-- confirm modal for automation delete & rest -->
    <confirm-modal
      :ref="`confirmation-automation-action`"
      :name="`confirmation-automation-action`"
      :buttonText="$t('frontend_delete')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="confirmMessage"
      @confirm="confirmAutomationAction"
      @closed="closeAutomationActionModal"
    />
  </div>
</template>
<script>
import axios from 'axios';
import Vue from 'vue';
import VSwitch from 'v-switch-case';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import themeConfig from '@/theme/themeConfig.js';
import Automation from '@/models/Automation';
import Automate from './automate.vue';

import EmptyListingState from '@/components/empty-listing-state.vue';
import showAlert from '@/components/sweet-alert-popup.js';

// import icons
import TriggersIcon from '@/assets/images/icons/auto-triggers.svg';
import ConditionsIcon from '@/assets/images/icons/auto-conditions.svg';
import ActionsIcon from '@/assets/images/icons/auto-actions.svg';

Vue.use(VSwitch);

export default {
  middleware: 'auth',
  data() {
    return {
      triggersPresent: false,
      selectedFilter: '',
      preTriggers: [],
      isLoading: false,
      vcase: 0,
      tabvalue: '',
      selectedOption: '',
      model: {
        name: '',
        status: 1,
        pre_mainselect: '',
        post_mainselect: '',
        prefields: [],
        postfields: [],
        pre_main_type: '',
        post_main_type: '',
        predata: '',
        predataname: '',
        preoperation: '',
        postdata: '',
        postdataname: '',
        postoperation: '',
        funnelid: '',
        productid: '',
        pricepointid: '',
        postfunnelid: '',
        postproductid: '',
        postpricepointid: '',
        postmembershipid: '',
        postaccesslevelid: '',
        affiliateActionType: '0',
        commissiontierid: '',
        integration_config: '',
        integrationId: '',
        broadcast_id: '',
        broadcast_link_id: '',
        sequence_id: '',
        email_node_id: '',
        sequence_email_node_link_id: '',
      },
      automations: [],
      automationId: '',
      confirmTarget: '',
      confirmMessage: '',
    };
  },
  validations: {
    model: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
    },
  },
  watch: {
    triggers() {
      if (this.triggersPresent) {
        this.preTriggers = this.triggers;
      } else {
        this.preTriggers = this.initalTriggers;
      }
    },
    actions() {
      const currentLocale = localStorage.getItem('lang');
      let currentLocaleLang = '';
      if (currentLocale === 'en') {
        currentLocaleLang = ENGLISH_LOCALE;
      } else if (currentLocale === 'pt') {
        currentLocaleLang = PORTUGESE_LOCALE;
      }

      if (this.$store.state.user.admin) {
        this.actions.push({
          value:
            currentLocaleLang.frontend_automations_actions_add_to_integration,
          dataType: 'add-integration',
          operation: '=',
          disabled: false,
        });
      }
    },
  },
  async created() {
    // show loader
    this.showLoader();

    this.automations = await Automation.$get();
    let autoIndex = 0;
    this.automations.forEach((ele) => {
      if (typeof ele.pre_condition === 'string') {
        this.automations[autoIndex].pre_condition = JSON.parse(
          ele.pre_condition
        );
      }
      if (typeof ele.post_condition === 'string') {
        this.automations[autoIndex].post_condition = JSON.parse(
          ele.post_condition
        );
      }
      autoIndex += 1;
    });
    this.tranformFetchedAutomations();
    // hide loader
    this.hideLoader();
  },
  async mounted() {
    this.preTriggers = this.initalTriggers;
    // this.actions.push({
    //   value: this.$t('frontend_automations_actions_add_to_integration'),
    //   dataType: 'add-integration',
    //   operation: '=',
    //   disabled: false,
    // });
  },
  methods: {
    closeAutomationModal(type) {
      this.automationModalClosed();
      if (type === 'add') {
        this.$root.$emit('modal-close', 'create-automation-modal');
      } else if (type === 'edit') {
        this.$root.$emit('modal-close', 'edit-automation-modal');
      }
    },

    automationModalClosed() {
      this.$refs.automationModal.automationModalClosed();
    },

    changedPreFields(event) {
      this.triggersPresent = !!event;
      if (event) {
        this.preTriggers = this.triggers;
      } else {
        this.preTriggers = this.initalTriggers;
      }
    },

    setFilter(event) {
      this.selectedFilter = event;
      const filterData = this.automationFilter.find((ele) => {
        return ele.identifier === event;
      });
      this.changetab(filterData.vcase, filterData.identifier);
    },

    // get the action options for the automation dropdown
    getActionOptions(automation) {
      const options = [
        { 
          value: 'edit',
          showValue: this.$t('frontend_groovemail_mail_lead_actions'),
          text: this.$t('frontend_edit')
        },
        { 
          value: 'duplicate',
          showValue: this.$t('frontend_groovemail_mail_lead_actions'),
          text: this.$t('frontend_duplicate')
        },
        { 
          value: 'remove',
          showValue: this.$t('frontend_groovemail_mail_lead_actions'),
          text: this.$t('frontend_remove')
        },
      ];

      if (automation.status === 1) {
        options.unshift({
          value: 'pause',
          showValue: this.$t('frontend_groovemail_mail_lead_actions'),
          text: this.$t('frontend_pause')
        });
      }

      if (automation.status === 0 || !automation.status) {
        options.unshift({
          value: 'resume',
          showValue: this.$t('frontend_groovemail_mail_lead_actions'),
          text: this.$t('frontend_resume')
        });
      }

      return options;
    },

    // handle the action change for the automation dropdown
    handleActionChange(selectedOption, index, automation) {
      switch (selectedOption) {
        case 'edit':
          this.editautomation(automation.id);
          break;
        case 'pause':
          this.changestatus(automation.id, index, automation.status);
          break;
        case 'resume':
          this.changestatus(automation.id, index, automation.status);
          break;
        case 'duplicate':
          this.cloneautomation(automation.id);
          break;
        case 'remove':
          this.automationActionModal('delete', automation.id);
          break;

        default:
      }
    },

    async changetab(i, value) {
      this.showLoader();
      this.vcase = i;
      this.tabvalue = value;
      const self = this;
      self.pre_tags = [];
      const { data } = await axios.get('/automation', {
        params: { search: value },
      });
      self.automations = data;
      let autoIndex = 0;
      self.automations.forEach((ele) => {
        if (typeof ele.pre_condition === 'string') {
          self.automations[autoIndex].pre_condition = JSON.parse(
            ele.pre_condition
          );
        }
        if (typeof ele.post_condition === 'string') {
          self.automations[autoIndex].post_condition = JSON.parse(
            ele.post_condition
          );
        }
        autoIndex += 1;
      });
      this.tranformFetchedAutomations();
      this.hideLoader();
    },

    opencreateautomation() {
      this.$root.$emit('modal-open', 'create-automation-modal');
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    // save the automation
    async savedetail() {
      this.$v.model.name.$touch();
      let preValidity = false;
      let postValidity = false;

      // check if the prefields is form
      if (this.model.prefields && this.model.prefields.length && this.model.prefields[0].type === 'form') {
        preValidity = true;
      }

      // check if the postfields is groovesell-cancel-subscription or groovesell-refund-order
      this.model.postfields.forEach((ele) => {
        if (
          ele.type === 'groovesell-cancel-subscription' ||
          ele.type === 'groovesell-refund-order'
          ) {
          postValidity = true;
        }
      });
      
      // check if the name is valid and prefields and postfields are not valid at the same time
      if (!this.$v.model.name.$invalid && !(preValidity && postValidity)) {
        this.showLoader();

        // create a new automation pased on the model data
        this.automation = new Automation({
          name: this.model.name,
          pre_condition: this.model.prefields,
          post_condition: this.model.postfields,
        });

        // save the new automation
        await this.automation.save()
          .then(() => {
            this.hideLoader();
            this.changetab(this.vcase, this.tabvalue);
          })
          .catch(() => {
            this.hideLoader();
            
            // show the error message
            this.requestErrorAlert();
          });
        
        // restart the model
        this.model.name = '';
        this.model.prefields = [];
        this.model.postfields = [];
        this.$v.model.name.$reset();

        // close the modal
        this.$root.$emit('modal-close', 'create-automation-modal');
      } else if (preValidity && postValidity) {
        // show the error message
        this.requestErrorAlert();
      }
    },

    // open confirm modal
    async automationActionModal(option, id) {
      // set the confirm target
      this.automationId = id;

      // set the target option
      this.confirmTarget = option;

      // check the option and set the confirm message
      if (option === 'delete') {
        this.confirmMessage = this.$t('frontend_groovemail_swal_revert_message');
      } else if (option === 'reset') {
        this.confirmMessage = this.$t('frontend_automations_warning_reset_stats');
      }
      
      // open the modal
      this.$refs[`confirmation-automation-action`].open();
    },

    // close confirm modal
    closeAutomationActionModal() {
      // close the modal
      this.$refs[`confirmation-automation-action`].close();

      // reset the confirm target
      this.confirmTarget = '';
      this.confirmMessage = '';
      this.automationId = '';
    },


    // confirm the confirm action
    confirmAutomationAction () {
      if(this.confirmTarget === 'delete') {
        this.deleteAutomtion();
      } else if(this.confirmtarget === 'reset') {
        this.reset();
      }
    },

    // delete the automation
    async deleteAutomtion() {
  
      this.showLoader();
      const automationDelete = await Automation.$find(this.automationId);

      // delete the automation
      await automationDelete.delete()
        .then(() => {
          const deletedAutomation = this.automations
            .map((item) => item.id)
            .indexOf(this.automationId);
          this.automations.splice(deletedAutomation, 1);
          this.hideLoader();
        })
        .catch(() => {
          // show the error message
          this.requestErrorAlert();
        });
    },

    // reset the automation stats
    async reset() {
      this.showLoader();

      // reset the automation stats
      await axios.get(`/resetstats/${this.automationId}`)
        .then(() => {
          // hide the loader
          this.hideLoader();
        })
        .catch(() => {
          // show the error message
          this.requestErrorAlert();
        });
    },

    // get the automation data by id and open the modal to edit the automation
    async editautomation(id) {
      this.showLoader();

      // get the automation data by id
      this.automation = await Automation.$find(id);

      // set the automation data to model
      this.model.name = this.automation.name;
      this.model.prefields = typeof this.automation.pre_condition === 'string'
          ? JSON.parse(this.automation.pre_condition)
          : this.automation.pre_condition;
      this.model.postfields = typeof this.automation.post_condition === 'string'
          ? JSON.parse(this.automation.post_condition)
          : this.automation.post_condition;

      this.tranformSavedPrePostFields();

      // open the modal to edit the automation
      this.$root.$emit('modal-open', 'edit-automation-modal');
      this.hideLoader();
    },

    // update the automation
    async updatedetail() {
      this.$v.model.name.$touch();
      let preValidity = false;
      let postValidity = false;

      // check if the prefields is form
      if (this.model.prefields && this.model.prefields.length && this.model.prefields[0].type === 'form') {
        preValidity = true;
      }

      // check if the postfields is groovesell-cancel-subscription or groovesell-refund-order
      this.model.postfields.forEach((ele) => {
        if (
          ele.type === 'groovesell-cancel-subscription' ||
          ele.type === 'groovesell-refund-order'
        ) {
          postValidity = true;
        }
      });

      // check if the name is valid and prefields and postfields are not valid at the same time
      if (!this.$v.model.name.$invalid && !(preValidity && postValidity)) {
        this.showLoader();

        // set the automation new data from model data
        this.automation.name = this.model.name;
        this.automation.pre_condition = this.model.prefields;
        this.automation.post_condition = this.model.postfields;
        
        // updated the automation data
        await this.automation.updateAutomation(this.automation.id, this.automation)
          .then(() => {
            this.hideLoader();

            this.changetab(this.vcase, this.tabvalue);

            // close the modal
            this.$root.$emit('modal-close', 'edit-automation-modal');

            // restart the model
            this.model.prefields = [];
            this.model.postfields = [];
            this.model.name = '';
            this.$v.model.name.$reset();

          })
          .catch(() => {
            // show the error message
            this.requestErrorAlert();
          });
      } else if (preValidity && postValidity) {
        // show the error message
        this.requestErrorAlert(); 
      }
    },

    tranformSavedPrePostFields() {
      let preFieldsIndex = 0;
      this.model.prefields.forEach(() => {
        if (
          typeof this.model.prefields[preFieldsIndex].id === 'object' &&
          typeof this.model.prefields[preFieldsIndex].name === 'object'
        ) {
          if (this.model.prefields[preFieldsIndex].id.length) {
            this.model.prefields[preFieldsIndex] = {
              ...this.model.prefields[preFieldsIndex].id[0],
              ...this.model.prefields[preFieldsIndex],
            };
            delete this.model.prefields[preFieldsIndex].id;
          }
          if (this.model.prefields[preFieldsIndex].name.length) {
            this.model.prefields[preFieldsIndex] = {
              ...this.model.prefields[preFieldsIndex].name[0],
              ...this.model.prefields[preFieldsIndex],
            };
            const currentName = Object.keys(
              this.model.prefields[preFieldsIndex].name[0]
            );
            let updatedName = '';
            let updateIndex = 0;
            currentName.forEach((newEle) => {
              if (updateIndex === currentName.length - 1) {
                updatedName += this.model.prefields[preFieldsIndex].name[0][
                  newEle
                ];
              } else {
                updatedName +=
                  `${this.model.prefields[preFieldsIndex].name[0][newEle]  }, `;
              }
              updateIndex += 1;
            });
            this.model.prefields[preFieldsIndex].name = updatedName;
          }
        }
        preFieldsIndex += 1;
      });
      let postFieldsIndex = 0;
      this.model.postfields.forEach(() => {
        if (
          typeof this.model.postfields[postFieldsIndex].id === 'object' &&
          typeof this.model.postfields[postFieldsIndex].name === 'object'
        ) {
          if (this.model.postfields[postFieldsIndex].id.length) {
            this.model.postfields[postFieldsIndex] = {
              ...this.model.postfields[postFieldsIndex].id[0],
              ...this.model.postfields[postFieldsIndex],
            };
            delete this.model.postfields[postFieldsIndex].id;
          }
          if (this.model.postfields[postFieldsIndex].name.length) {
            this.model.postfields[postFieldsIndex] = {
              ...this.model.postfields[postFieldsIndex].name[0],
              ...this.model.postfields[postFieldsIndex],
            };
            const currentName = Object.keys(
              this.model.postfields[postFieldsIndex].name[0]
            );
            let updatedName = '';
            let updateIndex = 0;
            currentName.forEach((newEle) => {
              if (updateIndex === currentName.length - 1) {
                updatedName += this.model.postfields[postFieldsIndex].name[0][
                  newEle
                ];
              } else {
                updatedName +=
                  `${this.model.postfields[postFieldsIndex].name[0][newEle]  }, `;
              }
              updateIndex += 1;
            });
            this.model.postfields[postFieldsIndex].name = updatedName;
          }
        }
        postFieldsIndex += 1;
      });
    },

    async changestatus(id, index, value) {
      this.showLoader();
      
      // update the automation status
      this.automation = await Automation.$find(id);
      const status = +!value;

      // updated the automation status
      await this.automation.updateAutomationStatue(id, status)
        .then((response) => {
          // update the automation status
          this.automations[index].status = response.data.status;

          // hide the loader
          this.hideLoader();
        })
        .catch(() => {
          // show the error message
          this.requestErrorAlert();
        });
    },

    async cloneautomation(id) {
      this.showLoader();
      this.automation = await Automation.$find(id);
      this.model.name = `${this.automation.name} [ ${this.$t('frontend_copy').toUpperCase()} ]`;
      this.model.prefields =
        typeof this.automation.pre_condition === 'string'
          ? JSON.parse(this.automation.pre_condition)
          : this.automation.pre_condition;
      this.model.postfields =
        typeof this.automation.post_condition === 'string'
          ? JSON.parse(this.automation.post_condition)
          : this.automation.post_condition;
      this.tranformSavedPrePostFields();
      this.$root.$emit('modal-open', 'create-automation-modal');
      this.hideLoader();
    },

    tranformFetchedAutomations() {
      let autoMateIndex = 0;
      this.automations.forEach((ele) => {
        let preCondIndex = 0;
        ele.pre_condition.forEach((preConele) => {
          if (typeof preConele.name === 'object' && preConele.name.length) {
            const currentName = Object.keys(preConele.name[0]);
            let updatedName = '';
            let updateIndex = 0;
            currentName.forEach((newEle) => {
              if (updateIndex === currentName.length - 1) {
                updatedName += preConele.name[0][newEle];
              } else {
                updatedName += `${preConele.name[0][newEle]  }, `;
              }
              updateIndex += 1;
            });
            this.automations[autoMateIndex].pre_condition[
              preCondIndex
            ].updatedName = updatedName;
          }
          preCondIndex += 1;
        });
        let postCondIndex = 0;
        ele.post_condition.forEach((postConele) => {
          if (typeof postConele.name === 'object' && postConele.name.length) {
            const currentName = Object.keys(postConele.name[0]);
            let updatedName = '';
            let updateIndex = 0;
            currentName.forEach((newEle) => {
              if (updateIndex === currentName.length - 1) {
                updatedName += postConele.name[0][newEle];
              } else {
                updatedName += `${postConele.name[0][newEle]  }, `;
              }
              updateIndex += 1;
            });
            this.automations[autoMateIndex].post_condition[
              postCondIndex
            ].updatedName = updatedName;
          }
          postCondIndex += 1;
        });
        autoMateIndex += 1;
      });
    },
  },

  computed: {
    // get the automation filter options
    automationFilterOptions() {
      return this.automationFilter.map(filter => ({
        text: filter.label,
        value: filter.identifier,
      }));
    },

    initalTriggers() {
      return [
        {
          value: this.$t(
            'frontend_groovemail_sequences_startingrules_lead_subscribers'
          ),
          dataType: 'list',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_automations_trigger_lead_unsubscribes_from_list'
          ),
          dataType: 'list',
          operation: '!=',
        },
        {
          value: this.$t('frontend_groovemail_sequences_startingrules_leadis'),
          dataType: 'tag',
          operation: '=',
        },
        {
          value: this.$t('frontend_automations_trigger_lead_fills_form'),
          dataType: 'form',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_automations_trigger_lead_subscribes_to_sequence'
          ),
          dataType: 'sequence',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_groovemail_leads_filter_opened_a_broadcast_option'
          ),
          dataType: 'groovemail-opened-broadcast-email',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_groovemail_leads_filter_clicked_a_link_option'
          ),
          dataType: 'groovemail-clicked-link-broadcast-email',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_groovemail_automations_trigger_opened_email_from_sequence'
          ),
          dataType: 'groovemail-opened-sequence-email',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_groovemail_automations_trigger_clicked_link_in_email_from_sequence'
          ),
          dataType: 'groovemail-clicked-link-sequence-email',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_automations_trigger_lead_purchased_a_product'
          ),
          dataType: 'groovesell-purchase',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_groovemail_automations_trigger_abandon_cart'
          ),
          dataType: 'groovesell-abandon-cart',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_automations_trigger_lead_refunded_a_product'
          ),
          dataType: 'groovesell-refund',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_automations_trigger_lead_cancel_a_subscription'
          ),
          dataType: 'groovesell-cancel-subscription',
          operation: '=',
        },
      ];
    },
    triggers() {
      return [
        {
          value: this.$t(
            'frontend_automations_trigger_lead_is_subscribed_to_list'
          ),
          dataType: 'list',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_automations_trigger_lead_is_not_subscribed_to_list'
          ),
          dataType: 'list',
          operation: '!=',
        },
        {
          value: this.$t('frontend_automations_trigger_lead_has_tag'),
          dataType: 'tag',
          operation: '=',
        },
        {
          value: this.$t('frontend_automations_trigger_lead_does_not_have_tag'),
          dataType: 'tag',
          operation: '!=',
        },
        {
          value: this.$t('frontend_automations_trigger_lead_has_filled_form'),
          dataType: 'form',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_automations_trigger_lead_is_subscribed_to_sequence'
          ),
          dataType: 'sequence',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_groovemail_leads_filter_opened_a_broadcast_option'
          ),
          dataType: 'groovemail-opened-broadcast-email',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_groovemail_leads_filter_clicked_a_link_option'
          ),
          dataType: 'groovemail-clicked-link-broadcast-email',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_groovemail_automations_trigger_opened_email_from_sequence'
          ),
          dataType: 'groovemail-opened-sequence-email',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_groovemail_automations_trigger_clicked_link_in_email_from_sequence'
          ),
          dataType: 'groovemail-clicked-link-sequence-email',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_automations_trigger_lead_purchased_a_product'
          ),
          dataType: 'groovesell-purchase',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_groovemail_automations_trigger_abandon_cart'
          ),
          dataType: 'groovesell-abandon-cart',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_automations_trigger_lead_refunded_a_product'
          ),
          dataType: 'groovesell-refund',
          operation: '=',
        },
        {
          value: this.$t(
            'frontend_automations_trigger_lead_cancel_a_subscription'
          ),
          dataType: 'groovesell-cancel-subscription',
          operation: '=',
        },
      ];
    },
    actions() {
      return [
        {
          value: this.$t('frontend_automations_actions_subscribe_to_list'),
          dataType: 'list',
          operation: '=',
          disabled: false,
        },
        {
          value: this.$t('frontend_automations_actions_unsubscribe_to_list'),
          dataType: 'list',
          operation: '!=',
          disabled: false,
        },
        {
          value: this.$t('frontend_automations_actions_add_tag'),
          dataType: 'tag',
          operation: '=',
          disabled: false,
        },
        {
          value: this.$t('frontend_automations_actions_remove_tag'),
          dataType: 'tag',
          operation: '!=',
          disabled: false,
        },
        {
          value: this.$t('frontend_automations_actions_subscribe_to_sequence'),
          dataType: 'sequence',
          operation: '=',
          disabled: false,
        },
        {
          value: this.$t(
            'frontend_automations_actions_unsubscribe_from_sequence'
          ),
          dataType: 'sequence',
          operation: '!=',
          disabled: false,
        },
        {
          value: this.$t('frontend_automations_actions_add_as_an_affiliate'),
          dataType: 'groovesell-add-affiliate',
          operation: '=',
          disabled: false,
        },
        {
          value: this.$t('frontend_automations_actions_refund_a_purchase'),
          dataType: 'groovesell-refund-order',
          operation: '=',
          disabled: false,
        },
        {
          value: this.$t(
            'frontend_automations_trigger_lead_cancel_a_subscription'
          ),
          dataType: 'groovesell-cancel-subscription',
          operation: '=',
          disabled: false,
        },
        {
          value: this.$t('frontend_automations_actions_add_a_membership'),
          dataType: 'add-member',
          operation: '=',
          disabled: false,
        },
      ];
    },
    automationFilter() {
      return [
        {
          vcase: 0,
          identifier: '',
          label: this.$t('frontend_groovemail_automations_filter_all'),
        },
        {
          vcase: 3,
          identifier: 'list',
          label: this.$t('frontend_groovemail_automations_filter_lists'),
        },
        {
          vcase: 5,
          identifier: 'tag',
          label: this.$t('frontend_groovemail_automations_filter_tags'),
        },
        {
          vcase: 8,
          identifier: 'sequence',
          label: this.$t('frontend_groovemail_automations_filter_sequences'),
        },
        {
          vcase: 9,
          identifier: 'form',
          label: this.$t('frontend_groovemail_automations_filter_forms'),
        },
        {
          vcase: 10,
          identifier: 'groovesell-purchase',
          label: this.$t(
            'frontend_groovemail_automations_filter_purchased_a_product'
          ),
        },
        {
          vcase: 11,
          identifier: 'groovesell-refund',
          label: this.$t(
            'frontend_groovemail_automations_filter_refunded_a_product'
          ),
        },
        {
          vcase: 12,
          identifier: 'groovesell-cancel-subscription',
          label: this.$t(
            'frontend_groovemail_automations_filter_cancelled_a_subscription'
          ),
        },
        {
          vcase: 13,
          identifier: 'groovesell-add-affiliate',
          label: this.$t(
            'frontend_groovemail_automations_filter_added_as_an_affiliate'
          ),
        },
        {
          vcase: 14,
          identifier: 'add-member',
          label: this.$t(
            'frontend_groovemail_automations_filter_added_a_membership'
          ),
        },
      ];
    },
  },
  components: {
    Automate,
    TriggersIcon,
    ConditionsIcon,
    ActionsIcon,
    EmptyListingState,
  },
};
</script>
<style lang="scss">
.automations-wrapper {
  .new-automation-add-btn {
    font-weight: 600;
    border-radius: 6px;
    font-size: 16px;
  }
}

select:focus {
  outline: none;
}
.icon-color {
  fill: #a4a8c0;
}
.automate {
  &-container:last-child {
    border-bottom: 1px solid #cccedc;
    border-radius: 0px 0px 4px 4px;
  }

  &-section-trigger,
  &-section-condition,
  &-section-action {
    width: 250px;
  }

  &-text-ellipse {
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
}

.automation-section-trigger,
.automation-section-action {
  max-width: 45%;
}

.auto-filters-dropdown {
 
  border-radius: 0.375rem;
}
</style>

<style scoped>
.gm-automations-refresh {
  min-height: 100%;
  padding: 28px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gm-automations-refresh__workspace {
  min-width: 0;
  padding: 20px 24px 24px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gm-automations-refresh__card {
  overflow: visible;
  border-color: var(--gs-border);
  border-radius: var(--gs-radius-md);
  box-shadow: var(--gs-shadow-sm);
}

@media (max-width: 640px) {
  .gm-automations-refresh { padding: 18px 12px 32px; }
  .gm-automations-refresh__workspace { padding: 16px; }
}
</style>
